var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGridViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#526981",
    d: "M6.581 8c.394 0 .73-.138 1.005-.414.276-.276.414-.61.414-1.005V1.42c0-.394-.138-.73-.414-1.005C7.31.138 6.976 0 6.581 0H1.42C1.025 0 .689.138.414.414.138.69 0 1.024 0 1.419V6.58c0 .394.138.73.414 1.005.276.276.61.414 1.005.414H6.58zm9 0c.394 0 .73-.138 1.005-.414.276-.276.414-.61.414-1.005V1.42c0-.394-.138-.73-.414-1.005C16.31.138 15.976 0 15.581 0H10.42c-.394 0-.73.138-1.005.414C9.138.69 9 1.024 9 1.419V6.58c0 .394.138.73.414 1.005.276.276.61.414 1.005.414h5.162zm-9 9c.394 0 .73-.138 1.005-.414.276-.276.414-.61.414-1.005V10.42c0-.394-.138-.73-.414-1.005C7.31 9.138 6.976 9 6.581 9H1.42c-.394 0-.73.138-1.005.414-.276.276-.414.61-.414 1.005v5.162c0 .394.138.73.414 1.005.276.276.61.414 1.005.414H6.58zm9 0c.394 0 .73-.138 1.005-.414.276-.276.414-.61.414-1.005V10.42c0-.394-.138-.73-.414-1.005-.276-.276-.61-.414-1.005-.414H10.42c-.394 0-.73.138-1.005.414-.276.276-.414.61-.414 1.005v5.162c0 .394.138.73.414 1.005.276.276.61.414 1.005.414h5.162z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridViewIcon);
export default __webpack_public_path__ + "static/media/grid-view-icon.bfc29d88552c9525107aeb6f10e721a0.svg";
export { ForwardRef as ReactComponent };